// extracted by mini-css-extract-plugin
module.exports = {"root":"CollezioneHeroSlide_root__69Ns1","rotation":"CollezioneHeroSlide_rotation__9SH66"};